document.addEventListener('DOMContentLoaded', () => {
  const selectCentroDeCustos = $('#centros_de_custos_');
  const SELECIONAR_TODOS = "selecionar_todos";
  if (selectCentroDeCustos.length < 1) return;

  selectCentroDeCustos.on('select2:select', function(e) {
    const data = e.params.data;
  
    if (data.id === SELECIONAR_TODOS) {
      let todasOpcoes = selectCentroDeCustos.find('option').map(function() {
        return this.value;
      }).get();
  
      selectCentroDeCustos.val(todasOpcoes).trigger('change');
    }
  });

  selectCentroDeCustos.on('select2:unselect', function(e) {
    const data = e.params.data;
  
    if (data.id === SELECIONAR_TODOS) {
      selectCentroDeCustos.val(null).trigger('change');
    }
  });
})